import createDocumentData from "../../utils/createDocumentData";

import { Export } from "./types/Export";

export default function createExportData(firebase, data) {
	const now = new Date();
	const oneMonthLater = new Date(now.setMonth(now.getMonth() + 1));

	return Export.parse(
		createDocumentData(firebase, "exports", {
			expires: firebase.firestore.Timestamp.fromDate(oneMonthLater),
			...data,
		}),
	);
}
